import React from 'react';
import styled from 'styled-components';
import { azure, gray10, white, spacer16, screenMdMin } from '@spotify-internal/encore-foundation';
import { Header } from './Header';
import { Hero } from './Hero';
import { Video } from './Video';
import { Features } from './Features';
import { ClaimBanner } from './ClaimBanner';
import { Testimonials } from './Testimonials';
import { Products } from './Products';
import { Faqs } from './Faq';
import { Footer } from './Footer';
import { GimletAcademy } from './GimletAcademy';

const LandingPageContainer = styled.div`
  color: ${white};
  background-color: ${gray10};
  background-image: url('/images/landing_page/header-bg.png');
  background-position: top ${spacer16} right -500px;
  background-repeat: no-repeat;
  background-size: 1975px 615px;
  @media (min-width: ${screenMdMin}) {
    background-position: top center;
  }
  @media (min-width: ${screenMdMin}) and (min-resolution: 192dpi) {
    background-image: url('/images/landing_page/header-bg@2x.png');
  }
`;

const DecorativeStripe = styled.div`
  display: none;

  @media (min-width: ${screenMdMin}) {
    background-color: ${azure};
    display: block;
    position: absolute;
    width: 100%;
    height: 332px;
  }
`;

const VideoDotsContainer = styled.div`
  display: none;

  @media (min-width: ${screenMdMin}) {
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    margin-top: 53px;
  }
`;

const TheDots = styled.div`
  background-image: url('/images/landing_page/white-dot-tile.png');
  background-repeat: repeat;
`;

const TheRightDots = styled.div`
  background-image: url('/images/landing_page/white-dot-tile-right.png');
  background-repeat: repeat;
`;

const ClaimDotsContainer = styled.div`
  display: none;

  @media (min-width: ${screenMdMin}) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    position: absolute;
    width: 100%;
    margin-top: 40px;
  }
`;

const TheClaimDots = styled.div`
  background-image: url('/images/landing_page/white-dot-tile.png');
  background-repeat: repeat;
  background-position: bottom left;
  width: 100%;
  height: 384px;
  clip-path: polygon(384px 0, 100% 0%, 100% 100%, 0% 100%);
  grid-column: 3;
  grid-row: 1;
`;

export function LandingPage() {
  return (
    <LandingPageContainer data-testid="landing-page--container">
      <Header />
      <Hero />
      <DecorativeStripe />
      <VideoDotsContainer>
        <TheRightDots style={{ flexGrow: 1, height: '150px', backgroundPosition: 'top right' }} />
        <div style={{ width: '630px' }} />
        <TheDots style={{ flexGrow: 1, height: '400px' }} />
      </VideoDotsContainer>
      <Video />
      <Features />
      <ClaimBanner />
      <DecorativeStripe />
      <ClaimDotsContainer>
        <TheClaimDots />
      </ClaimDotsContainer>
      <Testimonials />
      <Products />
      <GimletAcademy />
      <Faqs />
      <Footer />
    </LandingPageContainer>
  );
}
